module.exports = __webpack_public_path__ + "images/winter-special-bg.jpg";